// extracted by mini-css-extract-plugin
module.exports = {"error":"error_error__fB4gs","dummy":"error_dummy__UGC4h"};